<template>
<!--  :route-to="routeTo"-->
  <gj-link
      @click="routeClick">
    <slot></slot>
  </gj-link>
</template>

<script>
  import {adStore} from "../../../common/store";

  export default {
    name: "app-sd-ad-route-link",
    props: {
      adManager: {
        type: Object,
        default: null
      },
      adCampaignManager: {
        type: Object,
        default: null
      },
      adGroupManager: {
        type: Object,
        default: null
      }
    },
    computed: {
      routeTo() {
        if (this.adManager) {
          return {};
        } else if (this.adCampaignManager) {
          const marketId = this.adCampaignManager.marketId;
          const campaign = this.adCampaignManager.campaign;
          return {
            path: `/ad/sd-ad/ad-campaign-manager/${campaign.campaignId}`,
            query: {marketId}
          }
        } else if (this.adGroupManager) {
          const marketId = this.adGroupManager.marketId;
          const campaign = this.adGroupManager.campaign;
          const group = this.adGroupManager.group;
          return {
            path: `/ad/sd-ad/ad-group-manager/${campaign.campaignId}/${group.groupId}`,
            query: {marketId}
          }
        } else {
          return {};
        }
      }
    },
    methods: {
      routeClick() {
        if (this.adManager) {
          adStore.SD.campaign = null;
          adStore.SD.group = null;
        } else if (this.adCampaignManager) {
          adStore.SD.campaign = this.adCampaignManager.campaign;
          adStore.SD.campaignDate = this.adCampaignManager.date;
          adStore.SD.group = null;
        } else if (this.adGroupManager) {
          adStore.SD.campaign = this.adGroupManager.campaign;
          adStore.SD.group = this.adGroupManager.group;
          adStore.SD.campaignDate = this.adGroupManager.date;
          adStore.SD.groupDate = this.adGroupManager.date;
        }
      }
    }
  }
</script>

<style scoped>

</style>
